import {call, put, select} from "redux-saga/effects";
import * as api from "services/api";
import {
    errorDeleteCompany,
    errorResetCompanyCode,
    getCompaniesError,
    getCompaniesSuccess, successDeleteCompany, successResetCompanyCode,
    upsertCompanyError,
    upsertCompanySuccess
} from "store/reducer/company/reducer";
import {getErrorFromMessage} from "services/utils/utils";
import {selectedCompanyForUpsert} from "store/reducer/company/selectors";

export function* getCompaniesSaga() {
    try {
        const data = yield call([api, api.getCompanies]);
        yield put(getCompaniesSuccess(data.data));
    } catch (e) {
        console.log(e);
        yield put(getCompaniesError(getErrorFromMessage(e)));
    }
}

export function* upsertCompanySaga() {
    try {
        const selectedCompany = yield select(selectedCompanyForUpsert);
        const company = {
            ...selectedCompany
        }
        delete company.valid;
        yield call([api, api.upsertCompany], company);
        yield put(upsertCompanySuccess());
    } catch (e) {
        console.log(e);
        yield put(upsertCompanyError(getErrorFromMessage(e)));
    }
}
export function* companyChangeSecretCodeSaga({payload}) {
    try {
        const {id} = payload;
        yield call([api, api.companySecretCodeReset], id);
        yield put(successResetCompanyCode());
    } catch (e) {
        console.error(e);
        yield put(errorResetCompanyCode(getErrorFromMessage(e)));
    }
}
export function* companyDeleteSaga({payload}) {
    try {
        const {id} = payload;
        yield call([api, api.companyDeleteApi], id);
        yield put(successDeleteCompany());
    } catch (e) {
        console.error(e);
        yield put(errorDeleteCompany(getErrorFromMessage(e)));
    }
}